"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const app_types_1 = require("pages/app.types");
const vessel_types_1 = require("./vessel.types");
const initialState = {
    isLoading: true,
    isMutationLoading: false,
    isError: false,
    isFailed: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    mutationMode: false,
    dataContractor: [],
    dataItem: {
        id: '0',
        contractor_id: '',
        contractor_code: '',
        contractor_name: '',
        contractor: {
            id: '',
            contractor_code: '',
            contractor_name: '',
        },
        vessel_no: '',
        vessel_capacity: 0,
        is_active: {
            value: true,
            status: 'Active',
        },
        created_by: '',
        created_date: new Date(),
        modified_by: '',
        modified_date: new Date(),
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }],
    },
};
const vesselReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [vessel_types_1.vesselTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [vessel_types_1.vesselTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [vessel_types_1.vesselTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isFailed, isLoadingSubmit } = action.payload;
        return Object.assign(Object.assign({}, state), { isFailed, isMutationLoading: true, isLoadingSubmit: isLoadingSubmit, dataItem: dataItem ? dataItem : initialState.dataItem, mutationMode: mutationMode });
    },
    [vessel_types_1.vesselTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isLoading: false, isSuccess: false, isLoadingSubmit: false, isMutationLoading: false });
    },
    [vessel_types_1.vesselTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, mutationMode, isFailed, messageError } = action.payload;
        return Object.assign(Object.assign({}, state), { dataItem,
            isFailed,
            messageError,
            mutationMode, isLoadingSubmit: !isFailed, isLoading: true, dataGrid: state.dataGrid.map((item) => {
                if (item.id === dataItem.id)
                    return dataItem;
                return item;
            }) });
    },
    [vessel_types_1.vesselTypes.SET_DATA_CONTRACTOR]: (state, action) => {
        const dataContractor = action.payload;
        return Object.assign(Object.assign({}, state), { isMutationLoading: false, dataContractor });
    },
    [vessel_types_1.vesselTypes.ON_DELETE]: (state, action) => {
        const { dataItem, mutationMode } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: true, mutationMode: mutationMode, dataItem: initialState.dataItem, dataGrid: state.dataGrid.filter((item) => item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id)) });
    },
    [vessel_types_1.vesselTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [vessel_types_1.vesselTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { sort: action.payload }) });
    },
});
exports.default = vesselReducer;
